export class ServiceConfig {
  defaultProductService?: number;
  generateInvoice?: boolean = true;
  paymentTermsDays?: number;
  durationStep?: number = 0.5;
}
